/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TeamSettingsAdminSlack_team = {
    readonly id: string;
    readonly teamId: string;
    readonly teamName: string;
    readonly teamCalendarId: string | null;
    readonly " $refType": "TeamSettingsAdminSlack_team";
};
export type TeamSettingsAdminSlack_team$data = TeamSettingsAdminSlack_team;
export type TeamSettingsAdminSlack_team$key = {
    readonly " $data"?: TeamSettingsAdminSlack_team$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TeamSettingsAdminSlack_team">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TeamSettingsAdminSlack_team",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamName",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "teamCalendarId",
            "storageKey": null
        }
    ],
    "type": "Team",
    "abstractKey": null
} as any;
(node as any).hash = '632ad1f66d6c6308f588ad0f10a62f6e';
export default node;
